<template>
	<div class="f-map-marker">
		<table class="st-table st-table--full">
			<tr>
				<th class="st-table__th st-table__th--position"></th>
				<th>Address</th>
				<th>Title</th>
				<th class="st-table__th st-table__th--remove"></th>
			</tr>
			<draggable :element="'tbody'" v-model="value" :options="{forceFallback: true, animation: 150, handle:'.drag'}">
				<tr v-for="(marker, index) in value">
					<td class="st-table__td st-table__td--position"><i class="drag fa fa-bars"></i></td>
					<td>
						<vue-google-autocomplete
						    class="st-input st-input--sm st-input--full st-input--text"
						    :defaultvalue="marker.address"
							v-model="marker.address"
						 	ref="address"
							:id="'marker-'+index"
						    placeholder=""
						    :disabled="systemdisable">
						</vue-google-autocomplete>
					</td>
					<td>
						<input
						class="st-input st-input--sm st-input--full st-input--text"
						type="text"

						v-model="marker.title"
						v-validate="{required: true}"
						:name="'map-marker'"
						:disabled="systemdisable" />
					</td>
					<td class="st-table__td st-table__td--remove">
						<button type="button" @click="removeMapMarker(index)" class="st-btn st-btn--small">x</button>
					</td>
				</tr>
			</draggable>
			<tfoot>
				<tr>
					<td colspan="4">
						<button type="button" @click="addMapMarker" class="st-btn st-btn--small">+</button>
					</td>
				</tr>
			</tfoot>
		</table>
		<div class="error" v-show="errors.has(field.name)">
			{{ errors.first(field.name) }}
		</div>
		<a target="_blank" :href="getMarkerUrl(value)">Google Maps</a>
	</div>
</template>

<script>

import VueGoogleAutocomplete from '@/components/VueGoogleAutocomplete';
import fieldvalidation from '@/helpers/fieldvalidation';
import forEach from 'lodash/forEach';

export default {
	name: 'f-map-marker',
	components: {
		VueGoogleAutocomplete
	},
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value;
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	mounted(){
		if(typeof google.maps.places.Autocomplete == 'undefined'){
			console.error('Google Maps Autocomplete is not installed or ready!');
		}
	},
	methods: {
		...fieldvalidation,
		addMapMarker(ev){
			if(typeof this.value !== 'object') this.value = [];
			this.value.push({
				address: '',
				title:'',
			});
		},
		removeMapMarker(index){
			this.value.splice(index, 1);
		},
		getMarkerUrl(markers){
			var out 	= 'http://sales-tool.linienflug.design/map.html?',
				first	= true;

			forEach(markers, (value, key) => {
				if(!first) out += '&';
				out += 'markers[]='+encodeURI(value.address);
				first = false;
			});

			return out;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/f-map-marker.vue